
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import buscador from './buscador.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador
        }
    } )
    export default class Componente extends Vue
    {

        async mounted()
        {
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        @Prop()
        public Seleccionada: any;

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' ) onAbrir()
        {
            this.Abierto = true;
        }

        public Abierto: boolean = false;
        public Refresh: boolean = false;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
